import apiClient from "./apiClient";

export const createSuccessStory = (formData) => {
    return apiClient.post('/Admin/SuccessStory/Create', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getAllSuccessStories = () => {
    return apiClient.get('/Admin/SuccessStories');
};

export const updateSuccessStory = (id, formData) => {
    return apiClient.put(`/Admin/SuccessStory/Update/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const deleteSuccessStory = (id) => {
    return apiClient.delete(`/Admin/SuccessStory/Delete/${id}`);
};
